import React from "react";
import "./CustomBlog.css";
import { Button, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { handleContactRedirect } from "../../Components/handleContactRedirect";

export const CustomBlog = ({ blog, index, path }) => {
  const navigate = useNavigate();

  const handleRoute = () => {
    handleContactRedirect(navigate);
  };
  return (
    <div
      className={`customblog standard-padding ${index % 2 !== 0 ? "customblog-odd" : ""}`}
    >
      <div
        className={`customblog-img-container ${index % 2 !== 0 ? "customblog-img-container-odd" : ""}`}
      >
        <Image
          className={`customblog-img ${index % 2 !== 0 ? "customblog-img-odd" : ""}`}
          alt="img"
          src={blog.ImagePath}
        />
      </div>
      <div className="customblog-content">
        <h4 className="heading">{blog.Title}</h4>
        <Image
          className={`customblog-img2 `}
          alt="img"
          src={blog.ImagePath}
        />
        <p className="text">
          <div
            className="customblog-text"
            dangerouslySetInnerHTML={{ __html: blog.ShortDescription }}
          />
        </p>
        <Button
          className="customblog-button"
          variant="success"
          onClick={handleRoute}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          Enquire Now <FiArrowRight size={18} />
        </Button>
      </div>
    </div>
  );
};
